module.exports = __webpack_public_path__ + "img/ThatHotel.14ad7b2a.png";